import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, interval, takeUntil } from 'rxjs';
import { BaseComponent } from '@src/app/components';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'table-loading-timer',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './loading-timer.component.html',
  styleUrl: './loading-timer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingTimerComponent extends BaseComponent implements OnInit {
  @Output() stop = new EventEmitter<void>();

  timerValue: number = 0;
  milliseconds: number = 0;
  private stopTimer$ = new Subject<void>();

  ngOnInit() {
    this.stopTimer$.subscribe(() => {
      this.stop.emit();
    });
    this.startLoading();
  }

  override ngOnDestroy() {
    this.stopTimer();

    super.ngOnDestroy();
  }

  startLoading() {
    this.timerValue = 0;
    this.milliseconds = 0;
    interval(10) // Обновляем каждые 10 миллисекунд
      .pipe(takeUntil(this.stopTimer$))
      .subscribe(() => {
        this.milliseconds += 10;
        this.timerValue = Math.floor(this.milliseconds / 1000);
        this.cdr.markForCheck();
      });
  }

  stopLoading() {
    this.stopTimer$.next();
  }

  private stopTimer() {
    this.stopTimer$.next();
    this.stopTimer$.complete();
  }
}
